module.exports = __webpack_public_path__ + "app/img/headicon.b18b5c78.jpg";